import React, { useState, useEffect, useRef } from "react"
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import interactionPlugin from "@fullcalendar/interaction"

export function C({ teamGmail, isActive }) {
    const [accessToken, setAccessToken] = useState(localStorage.getItem("googleCalendarAccessToken"))
    const [events, setEvents] = useState([])
    const [view, setView] = useState("dayGridMonth")
    const calendarRef = useRef(null)
    const today = new Date()
    const startDate = new Date(today)
    const endDate = new Date(today)
    startDate.setMonth(startDate.getMonth() - 1)
    endDate.setMonth(endDate.getMonth() + 2)

    useEffect(() => {
        if (!accessToken) return
        fetchEvents()
        window.addEventListener("focus", fetchEvents)
        return () => window.removeEventListener("focus", fetchEvents)
    }, [accessToken, teamGmail])

    const login = useGoogleLogin({
        scope: "https://www.googleapis.com/auth/calendar.readonly",
        onSuccess: (tokenResponse) => {
            setAccessToken(tokenResponse.access_token)
            localStorage.setItem("googleCalendarAccessToken", tokenResponse.access_token)
        },
        onError: () => alert("Google login failed"),
    })

    const logout = () => {
        localStorage.removeItem("googleCalendarAccessToken")
        setAccessToken(null)
        setEvents([])
    }

    const fetchEvents = async () => {
        console.log('jjjj')
        if (!accessToken || !teamGmail) return
        console.log('hhh')
        try {
            const res = await fetch(
                `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(teamGmail)}/events?timeMin=${startDate.toISOString()}&timeMax=${endDate.toISOString()}&singleEvents=true&orderBy=startTime`,
                { headers: { Authorization: `Bearer ${accessToken}` } }
            )

            if (!res.ok) {
                if (res.status === 401) {
                    logout()
                    alert("יש להתחבר מחדש לגוגל")
                }
                return
            }

            const data = await res.json()
            const formatted = (data.items || []).map((event) => ({
                id: event.id,
                title: event.summary || "(No Title)",
                start: event.start.dateTime || event.start.date,
                end: event.end.dateTime || event.end.date,
                url: event.htmlLink,
            }))
            setEvents(formatted)
        }
        catch (error) {
            console.error(error)
        }
    }

    const handleDateClick = (arg) => {
        const calendarApi = calendarRef.current?.getApi()
        if (!calendarApi || !isActive) return

        if (view === "dayGridMonth") {
            calendarApi.changeView("timeGridDay", arg.dateStr)
            calendarApi.gotoDate(arg.dateStr)
            setView("timeGridDay")
        }
        else if (view === "timeGridDay") {
            const start = arg.date
            const end = new Date(start.getTime() + 60 * 60 * 1000)

            const title = encodeURIComponent("אירוע חדש")
            const details = encodeURIComponent("")
            const location = encodeURIComponent("")

            const formatDateForGoogle = (d) => d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z"
            const startDateGoogle = formatDateForGoogle(start)
            const endDateGoogle = formatDateForGoogle(end)

            const calendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${startDateGoogle}/${endDateGoogle}&details=${details}&location=${location}&sf=true&output=xml`
            window.open(calendarUrl, "_blank")
        }
    }

    const handleEventClick = (clickInfo) => {
        clickInfo.jsEvent.preventDefault()
        window.open(clickInfo.event.url, "_blank")
    }

    const handleDatesSet = (dateInfo) => setView(dateInfo.view.type)

    const formatDateISO = (date) => date.toISOString().split("T")[0]

    if (!teamGmail) return <div className="calendar">
        <p>הצוות הזה אינו מסונכן עם גוגל, לא ניתן להציג לוח שנה.</p>
    </div>

    return <div className="calendar">
        {!accessToken ? <>
            <p>לצפיה וסנכרון עם לוח השנה של הצוות שלך, יש להתחבר עם עם משתמש גוגל מתאים של {teamGmail.split('@')[1]}.</p>
            <div className="google" onClick={() => login()}>
                <img src={require('../style/imgs/google.png')} alt="google" />
                <span>התחבר</span>
            </div>
        </> : <div>
            <FullCalendar
                ref={calendarRef}
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                headerToolbar={{
                    left: "prev,next",
                    center: "title",
                    right: "dayGridMonth,timeGridDay",
                }}
                events={events}
                validRange={{ start: formatDateISO(startDate), end: formatDateISO(endDate) }}
                dateClick={handleDateClick}
                eventClick={handleEventClick}
                datesSet={handleDatesSet}
                navLinks={false}
                editable={false}
                selectable={true}
                locale="he"
                direction="rtl"
                slotLabelFormat={{
                    hour: 'numeric',
                    minute: '2-digit',
                    omitZeroMinute: false,
                    meridiem: 'short'
                }}
                slotDuration='00:30:00'
                slotLabelInterval={{ minutes: 30 }}
            />
            <div className="google" onClick={logout} style={{ marginBottom: '10px' }}>
                <img src={require('../style/imgs/google.png')} alt="google" />
                <span>התנתק</span>
            </div>
        </div>}
    </div>
}

export function CalendarCmp({ teamGmail, isActive }) {
    return <GoogleOAuthProvider clientId="1043832706068-sjv3fuc37gmnkrceat1ul6q5ph3ad5ih.apps.googleusercontent.com">
        <C teamGmail={teamGmail} isActive={isActive} />
    </GoogleOAuthProvider>
}